import React from "react";
import { Box, Typography } from "@mui/material";
import Login from "../auth/LoginPanel";

const TenantBrandingPreview = ({
  tenantName,
  logoUrl,
  primaryColor,
  secondaryColor,
}) => {
  return (
    <Box>
      <Typography variant="h6" gutterBottom>
        Login Preview
      </Typography>

      <Login
        previewMode={true}
        tenantBranding={{
          name: tenantName,
          logoUrl,
          primaryColor,
          secondaryColor,
        }}
      />
    </Box>
  );
};

export default TenantBrandingPreview;